const PageTitle = ({ children }) => {
  return <h3 className="custom-page-title">{children}</h3>
}

export default PageTitle
